'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _directionalMarkersGroup = require('./directionalMarkersGroup');

var _directionalMarkersGroup2 = _interopRequireDefault(_directionalMarkersGroup);

var _invalidCharsGroup = require('./invalidCharsGroup');

var _invalidCharsGroup2 = _interopRequireDefault(_invalidCharsGroup);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validUrlPrecedingChars = (0, _regexSupplant2.default)(/(?:[^A-Za-z0-9@＠$#＃#{invalidCharsGroup}]|[#{directionalMarkersGroup}]|^)/, {
  invalidCharsGroup: _invalidCharsGroup2.default,
  directionalMarkersGroup: _directionalMarkersGroup2.default
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validUrlPrecedingChars;
module.exports = exports['default'];